import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { postJson } from '@/utils/fetchOptions';

import { useAuthToken } from '../useAuth';
import { useMutation } from '../useMutation';

interface UseVerifyEmailProps {
  email: string;
  onSuccess?: (res: Api.UserObject | ResponseObject) => void;
}

export function useVerifyEmail({ email, onSuccess }: UseVerifyEmailProps) {
  const token = useAuthToken();
  const { setAlert } = useAppContext();

  const {
    isLoading,
    data = {},
    mutate,
    error
  } = useMutation({
    mutationKey: 'verifyEmail',
    mutationFn: async () =>
      postJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/user/email/verify`,
        body: { email },
        token
      }).then((response: TypeAny) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }
        return response;
      }),
    onSuccess
  });

  return {
    isLoading,
    mutate,
    error,
    data
  };
}
